import React from 'react';

const Logo = ({ className = 'text-2xl' }) => {
  return (
    <div className={`flex items-center font-bold ${className}`}>
      <svg
        className="h-8 w-8 mr-2"
        viewBox="0 0 52 42"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 36 A 20 20 0 0 1 46 36"
          stroke="#FBBF24" // amber-400
          strokeWidth="11"
          strokeLinecap="round"
        />
        <path
          d="M6 36 A 20 20 0 0 1 26 16"
          stroke="#FFF" // white for dashes
          strokeWidth="11"
          strokeLinecap="round"
          strokeDasharray="8 9"
        />
      </svg>
      <span className="text-yellow-400">Refer</span>
      <span className="text-white">Bridge</span>
    </div>
  );
};

export default Logo;